import BadgeDirective from './BadgeDirective';

export default angular.module('edge.platform.widgets.badge', [])
    .directive('gwBadge', BadgeDirective);